import { useNavigate } from 'react-router-dom'

// TODO: Remove the modals from here
import StepUpsertModal from 'modules/processes/components/ProcessSettings/Steps/StepUpsertModal'
import { useProcessContext } from 'modules/processes/pages/Process/ProcessRootPage'

const AddStepModalPage = () => {
  const navigate = useNavigate()
  const { process } = useProcessContext()

  const onClose = () => {
    navigate(-1)
  }

  if (!process) return null

  return <StepUpsertModal onClose={onClose} steps={process.steps} processId={process.id} />
}

export default AddStepModalPage
